import { render, staticRenderFns } from "./EmbedEditor.vue?vue&type=template&id=18fa2380&"
import script from "./EmbedEditor.vue?vue&type=script&lang=ts&"
export * from "./EmbedEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports